<nz-modal
  [(nzVisible)]="isShowConfirm"
  nzCentered
  [nzFooter]="null"
  nzCloseIcon="null"
>
  <ng-container *nzModalContent>
    <div class="text-center d-flex flex-column p-4">
      <div class="flex flex-col items-center">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
          alt="warning"
          width="100px"
        />
        <div class="title mt-3">Are you sure you want delete this team?</div>
      </div>
      <div class="d-flex justify-content-betweeen mt-3 gap-2">
        <button
          class="btn btn-primary text-white col-6"
          (click)="handleCancel()"
        >
          No
        </button>
        <button
          class="btn btn-outline-primary col-6"
          (click)="handleContinue()"
        >
          Yes
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>
